import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { MessageService } from 'primeng/api';
import { BroadcastMessageService, AppDataService } from 'app/services';
import {
    BroadcastMessageCreate,
    BroadcastUserTypeEnum,
    BroadcastMessageTypeModel, BroadcastReceiverTypeModel, BroadcastReceiverTypeEnum, BroadcastChannelTypeModel,
    XpressClientLocationTypeEnum, XpressClientLocationTypeModel
} from 'app/models';
import { BroadcastMessageComponent } from '../broadcast-message/broadcast-message.component';
import { Utils } from 'app/utils';

enum MenuTab {
    Details = 1,
    Message = 2
}

@Component({
    selector: 'broadcast-message-create',
    templateUrl: './broadcast-message-create.component.html',
    styleUrls: ['./broadcast-message-create.component.scss',
        '../../../../../styles/sidebar.scss',
        '../../../../../styles/style-layout.scss'
    ],
    providers: [MessageService]
})
export class BroadcastMessageCreateComponent implements OnInit {
    @Input() public broadcastMessageComponent!: BroadcastMessageComponent;

    public broadcastUserType!: BroadcastUserTypeEnum;
    @Input()
    set _broadcastUserType(value: BroadcastUserTypeEnum) {
        this.broadcastUserType = value;
        this.broadcastReceiverTypeList = BroadcastReceiverTypeModel.BroadcastReceiverTypeByUserTypeList(value);
    }

    @Input() public showBroadcastMessageCreateSideBar: boolean = false;

    @Output() changedShowBroadcastMessageCreateSideBarEmit = new EventEmitter<boolean>();
    changedShowBroadcastMessageCreateSideBar(increased: any) {
        this.changedShowBroadcastMessageCreateSideBarEmit.emit(increased);
    }

    public today = new Date();

    public menuTab = MenuTab;
    public activeMenuTab: MenuTab = MenuTab.Details;

    public broadcastReceiverTypeEnum = BroadcastReceiverTypeEnum;

    public broadcastMessage!: any;
    public broadcastMessageTypeList = BroadcastMessageTypeModel.BroadcastMessageTypeList;
    public broadcastChannelTypeList = BroadcastChannelTypeModel.BroadcastChannelTypeList;
    public broadcastReceiverTypeList = BroadcastReceiverTypeModel.BroadcastReceiverTypeList;
    public clientLocationTypeList = XpressClientLocationTypeModel.XpressClientLocationTypeList;

    private timer: number = 0;
    public loading: boolean = false;

    constructor(private messageService: MessageService,
        private broadcastMessageService: BroadcastMessageService,
        public appData: AppDataService)
    {
        this.broadcastMessage = new BroadcastMessageCreate();
    }

    ngOnInit(): void { }

    public createBroadcastMessage() {
        this.broadcastMessage.SenderUserId = this.appData.authData.UserId;
        this.broadcastMessage.BroadcastUserType = this.broadcastUserType;
        this.broadcastMessage.ClientLocationType = this.appData.getClientLocationType();

        const isCheck = this.checkBroadcastMessageFields();

        if (isCheck) {
            this.loading = true;
            this.broadcastMessageService.createBroadcastMessage(this.broadcastMessage, this.messageService)
                .then(data => {
                    if (!data) {
                        this.loading = false;
                        return;
                    }

                    if (!data.Success) {
                        this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                        this.loading = false;
                        return;
                    }

                    if (this.broadcastMessageComponent) {
                        this.broadcastMessageComponent.getBroadcastMessages(0);
                    }
                    this.cancel();
                })
                .catch(error => {
                    console.log(error);
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
                });
        }
    }

    public getTitle(value: BroadcastUserTypeEnum) {
        switch (value) {
            case BroadcastUserTypeEnum.Drivers: return 'Drivers';
            case BroadcastUserTypeEnum.Customers: return 'Customers';
            default: return '';
        }
    }

    private checkBroadcastMessageFields() {
        const requiredFields = [
            { field: this.broadcastMessage.SenderUserId, message: 'Sender user is required field' },
            { field: this.broadcastMessage.BroadcastUserType, message: 'User type is required field' },
            { field: this.broadcastMessage.BroadcastMessageType, message: 'Message Type is required field' },
            { field: this.broadcastMessage.BroadcastChannelType, message: 'Channel Type is required field' },
            { field: this.broadcastMessage.BroadcastStartDateTime, message: 'Start Date is required field' },
            { field: this.broadcastMessage.BroadcastReceiverType, message: 'Receiver Type is required field' },
            { field: this.broadcastMessage.MessageTitle, message: 'Message Title is required field' },
            { field: this.broadcastMessage.MessageSubTitle, message: 'Message Subtitle is required field' },
            { field: this.broadcastMessage.MessageText, message: 'Message Text is required field' }
        ];

        for (const { field, message } of requiredFields) {
            if (!field) {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: message });
                return false;
            }
        }

        return true;
    }

    public showFieldDay(receiverType: BroadcastReceiverTypeEnum) {
        switch (receiverType) {
            case BroadcastReceiverTypeEnum.HaventLoggedInXDays: { return true; }
            case BroadcastReceiverTypeEnum.SignedUpInLastXDay: { return true; }
            default: { return false;}
        }
    }

    public handleInputClick(id: string): void {
        document.getElementById(id)?.click();
    }

    public handleImageChange(event: Event) {
        const target = event.target as HTMLInputElement;

        let file: File | null = null;

        if (target.files) {
            file = target.files[0];
        }

        if (!file) {
            return;
        }

        // Chech max file size 2MB
        if (file.size > 2097152) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'This file is bigger than 2MB.' });
            return;
        }

        const reader = new FileReader();

        reader.onload = (e) => {
            if (e?.target?.result) {
                // Base64 string
                this.broadcastMessage.MessageImageUrl = e.target.result.toString();
            }
        };

        reader.readAsDataURL(file);
    }

    cancel() {
        this.changedShowBroadcastMessageCreateSideBar(false);
    }
}
